<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span class="lock" :title="$gettext('Sdílená váha. Nelze editovat.')" v-if="!$_updateActionAllowed" />
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <span class="lock" v-if="!$_updateActionAllowed" 	:title="'Sdílená váha. Nelze editovat.' | translate" v-translate>Zamčeno</span>
    <td :data-th="'Název váhy' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Value' | translate">
      {{ entity.value }}
    </td>
    <td :data-th="'Počet služeb' | translate" v-if="entity.services.length > 0">
      <span class="dotted" @click.stop="$refs.servicesmodalref.showModal(true)">
            {{ entity.services.length }}
          <modal ref="servicesmodalref">
            <div slot="title"><translate>Služby s přiřazenou vahou</translate> ({{entity.services.length}})</div>
            <div slot="body">
              <ul>
                <li v-for="(item, index) in entity.services" :key="'channels-'+index">{{item.name}}</li>
              </ul>
            </div>
          </modal>
      </span>
    </td>
    <td :data-th="'Počet služeb' | translate" v-else>
      {{ entity.services.length }}
    </td>
    <td :data-th="'Operátor' | translate" v-if="this.$_readActionAllowedAllOrOwnAndGlobal">
      {{ entity.operator_name }}
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteServiceWeightCategory">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "ServiceWeightCategoryRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      moduleName: 'serviceWeightCategories',
      detailPageRouteName: 'serviceWeightCategoryDetail',
    }
  },
  methods: {
    emitDeleteServiceWeightCategory() {
      this.$emit('deleteServiceWeightCategory', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/serviceWeightCategories/ServiceWeightCategoryRow.vue